module.exports = __webpack_public_path__ + "img/logo2.38710735.png";